import React, { useState } from 'react';
const faqs = [{
  q: 'È un prodotto cartaceo o digitale?',
  a: 'È un prodotto digitale al 100% in formato PDF ad alta risoluzione, utilizzabile su computer, tablet e smartphone.'
}, {
  q: 'Serve esperienza nel Functional Training?',
  a: 'No. Il sistema è stato progettato sia per coach alle prime esperienze sia per professionisti già affermati.'
}, {
  q: 'Posso utilizzarlo con lezioni di gruppo?',
  a: 'Assolutamente sì. Il sistema è stato creato per sessioni individuali, piccoli gruppi e classi numerose.'
}, {
  q: 'Posso adattare gli allenamenti ai miei clienti?',
  a: 'Sì. Il sistema include progressioni, regressioni e varianti per diversi livelli di preparazione.'
}, {
  q: 'Quando vedrò i primi benefici?',
  a: 'La maggior parte dei coach riferisce di risparmiare diverse ore di programmazione già durante la prima settimana.'
}, {
  q: 'Quali attrezzi sono necessari per gli allenamenti?',
  a: "Il sistema è flessibile: include esercizi a corpo libero, con kettlebell, manubri e piccoli attrezzi, adattabili all'attrezzatura che hai a disposizione."
}, {
  q: 'È un abbonamento mensile?',
  a: 'No, è un pagamento unico. Avrai accesso a vita a tutto il materiale senza alcun costo ricorrente.'
}, {
  q: 'Posso stampare le schede di allenamento?',
  a: 'Sì, tutto il materiale è formattato per essere facilmente stampato e portato in palestra con te.'
}, {
  q: 'I bonus sono inclusi nel prezzo?',
  a: 'Sì, tutti e 5 i Bonus Premium sono inclusi gratuitamente se acquisti oggi durante questa offerta.'
}, {
  q: 'Come funziona la garanzia?',
  a: 'Hai 7 giorni per provare il sistema. Se non sei soddisfatto, ti rimborsiamo il 100% senza farti domande.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-5 bg-cream" data-id="element-37">
      <h2 className="text-2xl font-heading font-bold text-center text-petrol mb-6" data-id="element-38">
        DOMANDE FREQUENTI
      </h2>

      <div className="flex flex-col gap-2" data-id="element-39">
        {faqs.map((faq, i) => <div key={i} className="bg-white border border-cream" data-id="element-40">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center" data-id="element-41">
              <span className="font-bold text-petrol text-sm font-subheading pr-4" data-id="element-42">
                {faq.q}
              </span>
              <span className="text-sage text-lg font-bold" data-id="element-43">
                {openIndex === i ? '−' : '+'}
              </span>
            </button>
            {openIndex === i && <div className="px-4 pb-3 pt-1 text-graphite text-sm" data-id="element-44">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}